<template>
  <v-container fluid>
    <v-list two-line class="rounded-xl">
      <!-- Income -->
      <v-list-item>
        <v-list-item-avatar tile>
          <v-img src="@/assets/icons/home/income-chart.png" contain />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>Income</v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-progress-circular
            indeterminate
            v-if="isLoading"
          ></v-progress-circular>
          <span class="text-xs-right" v-else>{{ income | currency }}</span>
        </v-list-item-action>
      </v-list-item>

      <v-divider></v-divider>

      <!-- Card -->
      <v-list-item>
        <v-list-item-avatar tile>
          <v-img src="@/assets/icons/home/credit-card.png" contain />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>Card</v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-progress-circular
            indeterminate
            v-if="isLoading"
          ></v-progress-circular>
          <span class="text-xs-right" v-else>{{ cardAmount | currency }}</span>
        </v-list-item-action>
      </v-list-item>

      <v-divider></v-divider>

      <!-- Other Payments -->
      <v-list-item>
        <v-list-item-avatar tile>
          <v-img src="@/assets/icons/home/bill1.png" contain />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>Other Payments</v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-progress-circular
            indeterminate
            v-if="isLoading"
          ></v-progress-circular>
          <span class="text-xs-right" v-else>{{
            otherPayment | currency
          }}</span>
        </v-list-item-action>
      </v-list-item>

      <v-divider></v-divider>

      <!-- Cash -->
      <v-list-item>
        <v-list-item-avatar tile>
          <v-img src="@/assets/icons/home/cash-money.png" contain />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>Cash</v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-progress-circular
            indeterminate
            v-if="isLoading"
          ></v-progress-circular>
          <span class="text-xs-right" v-else>{{ cashAmount | currency }}</span>
        </v-list-item-action>
      </v-list-item>

      <v-divider></v-divider>

      <!-- Expense -->
      <v-list-item @click="expenseReport('expense')" class="cursor-pointer">
        <v-list-item-avatar tile>
          <v-img src="@/assets/icons/home/calculator.png" contain />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>Expense</v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-progress-circular
            color="red"
            indeterminate
            v-if="isLoading"
          ></v-progress-circular>
          <span class="text-xs-right" v-else>{{ expense | currency }}</span>
        </v-list-item-action>
      </v-list-item>

      <v-divider></v-divider>

      <!-- Cash In Hand -->
      <v-list-item>
        <v-list-item-avatar tile>
          <v-img src="@/assets/icons/home/cash-flow.png" contain />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">
            Cash In Hand
          </v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-progress-circular
            indeterminate
            v-if="isLoading"
          ></v-progress-circular>
          <span class="text-xs-right font-weight-bold" v-else>
            {{ cashInHand | currency }}
          </span>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-container>
</template>

<script>
import locationService from "@/modules/Location/service.js";

export default {
  name: "SaleBaseTileMini",
  props: ["dateTime", "id"],
  data() {
    return {
      isLoading: true,
      openInvoice: 0,
      Revenue: 0,
      Discounts: 0,
      InvoiceCount: 0,
      customerCount: 0,
      NetSales: 0,
      expense: 0,
      NetProfit: 0,
      income: 0,
      TaxCollected: 0,
      cashAmount: 0,
      cardAmount: 0,
      otherPayment: 0,
      cashInHand: 0,
    };
  },
  mounted() {
    this.loadData();
  },
  watch: {
    dateTime() {
      this.loadData();
    },
  },
  methods: {
    expenseReport() {
      const routeData = this.$router.resolve({
        path: `/reports/expenses?start=${this.dateTime.start}&end=${this.dateTime.end}&type=noExternalPayments&locationId=${this.id}`,
      });
      window.open(routeData.href, "_blank");
      window.postMessage({
        action: "OPENREPORT",
        data: routeData.href,
      });
    },
    loadData() {
      this.isLoading = true;
      locationService.Reports.getLocationSales({
        start: this.dateTime.start,
        end: this.dateTime.end,
        LocationId: this.id,
      })
        .then((response) => {
          const d = response.data;
          this.Revenue = parseFloat(d.revenue);
          this.InvoiceCount = d.invoiceCount;
          this.Discounts = parseFloat(d.discounts);
          this.NetSales = parseFloat(d.netSales);
          this.NetProfit = parseFloat(d.netProfit);
          this.TaxCollected = parseFloat(d.taxCollected);
          this.cashAmount = parseFloat(d.cashAmount);
          this.otherPayment = parseFloat(d.otherPaymentAmount);
          this.customerCount = parseFloat(d.customerCount);
          this.expense = parseFloat(d.expense);
          this.cardAmount =
            parseFloat(d.creditCardAmount) + parseFloat(d.debitCardAmount);
          this.income = this.otherPayment + this.cashAmount + this.cardAmount;
          this.cashInHand =
            parseFloat(this.cashAmount) - parseFloat(this.expense);
          this.openInvoice = d.openInvoice;
        })
        .catch((error) => {
          console.error("Error loading location sales", error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    nFormatter(num, digits) {
      const si = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "k" },
        { value: 1e6, symbol: "M" },
        { value: 1e9, symbol: "G" },
      ];
      const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
      let i = si.length - 1;
      while (i > 0 && num < si[i].value) i--;
      return (
        (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol
      );
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>